import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ModuleGroup } from '../models/modulegroup.model';
import { Module } from '../models/module.model';
import { NavigationReference } from '../models/navigationreference.model';
import { genId } from "../../core/services/genId";

@Injectable()
export class ModuleGroupService {
  public readonly BaseUrl = '/api/modulegroup';

  constructor(public http: HttpClient) { }

  createModule(moduleGroupId: string, module: Module): Observable<Module> {
    module.id = genId();
    return this.http.post<Module>(`${this.BaseUrl}/${moduleGroupId}/modules`, module);
  }

  createReference(moduleGroupId: string, moduleId: string, link: NavigationReference): Observable<NavigationReference> {
    return this.http.post<NavigationReference>(`${this.BaseUrl}/${moduleGroupId}/modules/${moduleId}`, link);
  }

  deleteModule(moduleGroupId: string, moduleId: string): Observable<string> {
    return this.http.delete<string>(`${this.BaseUrl}/${moduleGroupId}/modules/${moduleId}`);
  }

  deleteModuleGroup(moduleGroupId: string): Observable<string> {
    return this.http.delete<string>(`${this.BaseUrl}/${moduleGroupId}`);
  }

  deleteReference(moduleGroupId: string, moduleId: string, id: string): Observable<string> {
    return this.http.delete<string>(`${this.BaseUrl}/${moduleGroupId}/modules/${moduleId}/${id}`);
  }

  getAll(): Observable<Array<ModuleGroup>> {
    return this.http.get<Array<ModuleGroup>>(this.BaseUrl);
  }

  getModuleGroup(moduleGroupId: string): Observable<ModuleGroup> {
    return this.http.get<ModuleGroup>(`${this.BaseUrl}/${moduleGroupId}`);
  }

  postModuleGroup(moduleGroup: ModuleGroup): Observable<ModuleGroup> {
    if (!moduleGroup.id)
      moduleGroup.id = genId();

    return this.http.post<ModuleGroup>(`${this.BaseUrl}`, moduleGroup);
  }
}